import { View } from 'foundations-components/transitional/components/View';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PracticalExerciseCondensedWrapper = ({
  buttons,
  children
}) => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "practical-exercise-wrapper",
    children: [/*#__PURE__*/_jsx(View, {
      padding: "700",
      children: children
    }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      children: buttons
    })]
  });
};
export default PracticalExerciseCondensedWrapper;